import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'
import { LegalScreen } from '@/screens/accounts/SCR-111-114-info'

// SCR-113 Terms and privacy (accounts area). Draft text, pending legal review.
export const Route = createFileRoute('/_public/legal')({
  validateSearch: z.object({ tab: z.enum(['terms', 'privacy']).optional().catch(undefined) }),
  component: function Legal() {
    const { tab } = Route.useSearch()
    const navigate = useNavigate({ from: '/legal' })
    return <LegalScreen tab={tab ?? 'terms'} onTab={t => void navigate({ search: { tab: t }, replace: true })} />
  },
})
